import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, Routes } from '@angular/router';
import { FeatureService } from './feature.service';
import { ZITI_BETA_LIST_ROUTES } from './urls';

// Sends an old list URL to its beta list while beta is on, so Save, Cancel and Back from an edit page land on the new list.
export const betaListRedirectGuard: CanActivateFn = (route, state) => {
    const path = state.url.split('?')[0].split('#')[0];
    const betaUrl = inject(FeatureService).betaListRoute(path);
    return betaUrl === path ? true : inject(Router).createUrlTree([betaUrl], { queryParams: route.queryParams });
};

// Also run as canActivateChild: when the edit page is a child of the list route, going back reuses the parent and skips its canActivate.
export const betaListRedirectChildGuard: CanActivateChildFn = (route, state) => betaListRedirectGuard(route, state);

// Adds the guards to every route that serves a legacy list URL; they only redirect on that exact URL, never on its children.
export function withBetaListRedirect(routes: Routes): Routes {
    return routes.map((route) =>
        route.path !== undefined && !route.redirectTo && `/${route.path}` in ZITI_BETA_LIST_ROUTES
            ? {
                  ...route,
                  canActivate: [...(route.canActivate ?? []), betaListRedirectGuard],
                  canActivateChild: [...(route.canActivateChild ?? []), betaListRedirectChildGuard],
              }
            : route
    );
}
